export const defaultState = () => {
  if (!window.__gem_api_root) window.__gem_api_root = "/";
  return {
    shopInfo: null,
    hideLanguage: true,
    status: {
      loading: false,
      error: null,
      success: null
    },
    unlinkStatus: {
      loading: false,
      error: null,
      success: null
    },
    permissions: {},
    agency: {},
    gethelp: new Array({
      key: String,
      value: new Array({
        id: String,
        order: Number,
        relatedLinks: new Array({
          order: Number,
          title: String,
          url: String
        }),
        title: String,
        url: String,
        video: String
      })
    }),
    language: {
      list: [],
      loading: false,
      fetched: false,
      map: {}
    },
    showPlanPopup: false,
    isModalPopup: false,
    limitationAlert: {
      subpages: false,
      homepages: false,
      productpages: false,
      collectionpages: false,
      articlepages: false
    },
    instantShopId: "",
    instantShopToken: "",
  };
};

const state = defaultState();

export default state;
